import { getToken, onMessage } from 'firebase/messaging';
import { env, messaging, vapidKey } from '../firebase';
import { ProfileType } from '../models/profileType';
import { ProfileService } from '../services/profile/profile';



export const requestPermissionAndGetToken = async (profile: ProfileType) => {
    try {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;

        const token = await getToken(messaging, {
            vapidKey: vapidKey,
            serviceWorkerRegistration: await navigator.serviceWorker.register(env === "production" ?
                '/firebase-messaging-sw-prod.js' :
                '/firebase-messaging-sw-qa.js'),
        });
        let fcmTokens = profile.fcmTokenList
        let tokenListChanged = false
        if (!fcmTokens) {
            tokenListChanged = true
            fcmTokens = [token]
        } else {
            tokenListChanged = true
            if (!fcmTokens.includes(token)) {
                fcmTokens.push(token)
            }
        }
        if (tokenListChanged) {
            ProfileService.updateProfile(profile.id, { fcmTokenList: fcmTokens })
        }
        console.log('FCM Token:', token);
        return token; // Save this to Firestore or your backend
    } catch (err) {
        console.error('Error getting FCM token:', err);
    }
};

// Handle foreground messages
onMessage(messaging, (payload) => {
    console.log('Foreground message:', payload);
});
